import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { variantsMessages } from './messages';

const StyledUnavailable = styled.p`
  ${theme.typography.labelSmall400}
  color: ${theme.color.text.secondary};
`;

export const Unavailable = () => {
  return (
    <StyledUnavailable>
      <FormattedMessage {...variantsMessages.unavailable} />
    </StyledUnavailable>
  );
};
